module.exports = __webpack_public_path__ + "static/img/fileIcon.f231dc56.png";